export default __webpack_public_path__ + "static/media/dropoff-address.c3145673.svg";